<template>
  <page-view :avatar="avatar" :title="false">
    <div slot="headerContent">
      <div class="title">
        {{ timeFix }}，{{ userInfo.userName }}
        <!-- <span class="welcome-text">，{{ welcome }}</span> -->
      </div>
      <div>
        <a-button
          v-if="merchantAuthSta == 'I'"
          type="primary"
          size="small"
          ghost
          >已认证</a-button
        >
        <a-button v-else size="small" type="danger" ghost>未认证</a-button>
        <a-divider type="vertical" />
        <a-button
          v-if="userInfo.userType == '2'"
          type="primary"
          size="small"
          ghost
          >管家</a-button
        >
        <a-button
          v-if="userInfo.userType == '3'"
          type="primary"
          size="small"
          ghost
          >房东</a-button
        >
        <a-divider type="vertical" />
        <a-button type="primary" size="small" ghost>{{
          merchantName
        }}</a-button>
        <a-divider type="vertical" />
        <a-button type="primary" size="small" ghost @click="exportQr()"
          >商家主页二维码</a-button
        >
      </div>
    </div>
    <div>
      <a-row :gutter="24">
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="出租房源"
            keyId="1"
            :total="dashboardData.inRentCnt"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="出租信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div>
              <mini-progress
                :color="inRentColor"
                :target="80"
                :percentage="dashboardData.fullRate"
                height="8px"
              />
            </div>
            <template slot="footer">
              出租率
              <span>{{ dashboardData.fullRate }}%</span>
            </template>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="空置房源"
            keyId="2"
            :total="dashboardData.notRentCnt"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="空置信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div>
              <mini-progress
                :color="notRentColor"
                :target="20"
                :percentage="dashboardData.emptyRate"
                height="8px"
              />
            </div>
            <template slot="footer">
              空置率
              <span>{{ dashboardData.emptyRate }}%</span>
            </template>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="访问量"
            keyId="3"
            :total="dashboardData.browseCnt"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="访问信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div>
              总访问量
              <!-- <mini-area /> -->
            </div>
            <template slot="footer">
              今日访问
              <span>{{ dashboardData.todayBrowseCnt }}</span>
            </template>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="收藏量"
            :total="dashboardData.collectionCnt"
            keyId="4"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="收藏信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div><a>快速进入 &gt;</a></div>
            <template slot="footer">
              今日收藏
              <span>{{ dashboardData.todayCollectionCnt }}</span>
            </template>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="合同余量"
            keyId="8"
            :total="dashboardData.contractCnt"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="合同剩余数量" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div>
              <mini-progress
                color="rgb(19, 194, 194)"
                :target="10"
                :percentage="
                  dashboardData.contractCnt > 100
                    ? 100
                    : dashboardData.contractCnt
                "
                height="8px"
              />
            </div>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="预约"
            keyId="5"
            :total="dashboardData.makeCnt"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="预约信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div><a>快速进入 &gt;</a></div>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="租约管理"
            keyId="6"
            :total="dashboardData.signCnt"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="所有的租约信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div><a>快速进入 &gt;</a></div>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="交租管理"
            keyId="7"
            :total="dashboardData.rentCnt"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="近一个月需要交租的信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <div><a>快速进入 &gt;</a></div>
          </chart-card>
        </a-col>

        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="添加房源"
            keyId="9"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="快速进入添加房源操作" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <!-- <div style="font-size: 35px;text-align: center;">
              <a-icon type="upload" />
            </div> -->
            <div><a>快速进入 &gt;</a></div>
            <template slot="footer"></template>
          </chart-card>
        </a-col>
        <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
          <chart-card
            :loading="loading"
            title="管家列表"
            keyId="10"
            @chartCardClick="chartCardClick"
          >
            <a-tooltip title="点击进入查看管家信息" slot="action"
              ><a-icon type="info-circle-o"
            /></a-tooltip>
            <!-- <div style="font-size: 35px;text-align: center;">
              <a-icon type="unordered-list" />
            </div> -->
            <div><a>快速进入 &gt;</a></div>
            <template slot="footer"></template>
          </chart-card>
        </a-col>
      </a-row>
    </div>

    <!-- 二维码 -->
    <div class="qr-code">
      <vue-qr
        :text="qrUrl"
        :logoSrc="logo"
        :logoCornerRadius="10"
        :callback="qrCallBack"
        qid="testid"
      ></vue-qr>
    </div>
  </page-view>
</template>

<script>
import { timeFix } from "@/utils/util";
import { mapState } from "vuex";
import { ChartCard, MiniProgress } from "@/components";
import { PageView } from "@/layouts";
import VueQr from "vue-qr";
export default {
  name: "Workplace",
  components: {
    PageView,
    ChartCard,
    MiniProgress,
    VueQr
  },
  data() {
    return {
      timeFix: timeFix(),
      avatar: "",
      loading: true,
      merchantAuthSta: "",
      merchantName: "",
      dashboardData: {
        collectionCnt: 0, //收藏总量
        todayCollectionCnt: 0, //今日收藏量
        contractCnt: 0, //合同余量
        inRentCnt: 0, //在租房源
        notRentCnt: 0, //空置房源
        rentCnt: 0, //交租管理
        signCnt: 0, //租约管理
        todayBrowseCnt: 0, //今日浏览
        browseCnt: 0, //总浏览量
        makeCnt: 1, //预约
        fullRate: 0, //出租率
        emptyRate: 0 //空置率
      },
      inRentColor: "#13c2c2", //颜色区域正常，预警，严重
      notRentColor: "#13c2c2",

      logo: "",
      qrUrl: "",
      isCreate: false,
      merchant: {
        logo: "",
        name: "",
        no: ""
      }
    };
  },
  computed: {
    ...mapState({
      nickname: state => state.user.nickname,
      welcome: state => state.user.welcome
    }),
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  created() {
    this.avatar = this.userInfo.avatar;
    let merchantInfo = this.userInfo.merchant.merchantInfo;
    if (merchantInfo) {
      this.merchantAuthSta = merchantInfo.authSta;
      if (merchantInfo.merchantType == 1) {
        this.merchantName = this.userInfo.merchant.enterprise.enterpriseName;
      } else {
        this.merchantName = this.userInfo.merchant.personal.realName;
      }
      this.merchant.no = this.userInfo.merchantNo;
      this.merchant.name = merchantInfo.merchantName;
      if (merchantInfo && merchantInfo.logo) {
        this.merchant.logo = merchantInfo.logo;
      }
    }
    this.getHomeData();
  },
  methods: {
    getHomeData() {
      let param = {};
      if (this.userInfo.userType == 2) {
        param.account = this.userInfo.userNo;
        param.userType = "keeper";
      } else {
        param.account = this.userInfo.merchantNo;
        param.userType = "merchant";
      }
      this.$http.roomBksApi
        .findHomeData(param)
        .then(res => {
          let result = res.resultObject;
          Object.assign(this.dashboardData, result);
          const total = result.inRentCnt + result.notRentCnt;
          this.dashboardData.fullRate = Math.floor(
            (result.inRentCnt / total) * 100
          );
          this.dashboardData.emptyRate = 100 - this.dashboardData.fullRate;
          if (
            this.dashboardData.fullRate >= 50 &&
            this.dashboardData.fullRate < 80
          ) {
            this.inRentColor = "#ffff00";
          } else if (this.dashboardData.fullRate < 50) {
            this.inRentColor = "#ff3300";
          }
          if (
            this.dashboardData.emptyRate > 20 &&
            this.dashboardData.emptyRate <= 50
          ) {
            this.notRentColor = "#ffff00";
          } else if (this.dashboardData.emptyRate > 50) {
            this.notRentColor = "#ff3300";
          }
        })
        .finally(() => {
          this.loading = !this.loading;
        });
    },
    chartCardClick(key) {
      if (key == 1 || key == 2) {
        let v = "";
        if (key == 1) {
          v = "2";
        } else {
          v = "0";
        }
        this.$router.push({
          name: "HouseList",
          query: { param: { rentSta: v } }
        });
      } else if (key == 9) {
        this.$router.push({ name: "AddHouse" });
      } else if (key == 10) {
        this.$router.push({ name: "keeper" });
      } else if (key == 4) {
        this.$router.push({ name: "StarList" });
      } else if (key == 5) {
        this.$router.push({ name: "make" });
      } else if (key == 6) {
        this.$router.push({ name: "LeaseList" });
      } else if (key == 7) {
        this.$router.push({ name: "LeaseRentList" });
      } else if (key == 8) {
        this.$router.push({ name: "ContractList" });
      }
    },
    exportQr() {
      this.isCreate = true;
      this.qrUrl =
        "https://www.xuroom.com/merchant?merchantNo=" +
        this.merchant.no +
        "&merchantName=" +
        this.merchant.name +
        "&logo=" +
        this.merchant.logo;
      this.logo = this.merchant.logo;
      console.log(this.qrUrl);
    },
    qrCallBack(dataUrl, id) {
      if (this.isCreate) {
        this.isCreate = false;
        var a = document.createElement("a");
        a.href = dataUrl;
        a.download = "qrcode" + new Date().getTime();
        a.click();
        setTimeout(() => {
          this.logo = "";
          this.qrUrl = "";
        }, 300);
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "~@/components/index.less";
.anticon {
  color: @primary-color;
}
.mobile {
  .project-list {
    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}

.qr-code {
  z-index: -100;
  position: absolute;
  top: 0;
}
</style>
